import { z } from 'zod';

/**
 * Identity fields of the company to be created. Blank values are dropped before
 * sending: the API treats an absent identifier as "not submitted".
 */
export const zodCompanyDuplicateCheckPayloadSchema = z.object({
  gln: z.string().trim().nullish(),
  hra: z.string().trim().nullish(),
  hraRegisterCourt: z.string().trim().nullish(),
  hrb: z.string().trim().nullish(),
  name: z.string().trim().min(1).max(255),
  registerCourt: z.string().trim().nullish(),
  vatId: z.string().trim().nullish(),
});

/** A `409 Conflict` body identifies the company and identifier that block creation. */
export const zodCompanyDuplicateSchema = z.object({
  matchedCompanyId: z.uuid(),
  matchedCompanyName: z.string(),
  matchedField: z.enum(['vat_id', 'hrb', 'hra', 'gln']),
  outcome: z.literal('duplicate'),
});
